import { render } from "./Statistics.vue?vue&type=template&id=b7207d4a&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"

import "./Statistics.vue?vue&type=style&index=0&id=b7207d4a&scoped=true&lang=css"

import exportComponent from "C:\\Program Files\\Jenkins\\.jenkins\\workspace\\Статистика приема\\Univeris.AdmissionStatistics.Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7207d4a"]])

export default __exports__